<div class="text-right">
  <button class="btn btn-light hover-button back" (click)="backClick()">
    <mat-icon>keyboard_backspace</mat-icon>&nbsp; Back To Fleet View
  </button>
</div>
<div class="graph">
  <div class="chart-title">
    <span class="info" >
      Segment Composition
      <mat-icon class="info" matTooltip="Pie chart represents aggregate number for each segment">info</mat-icon>
    </span>
  </div>
  <div #pieChartContainer [chart]="pieChart"></div>
</div>
